module.exports = __webpack_public_path__ + "static/media/tom-4.a1d2e987.mp3";